<template>
  <div class='dialog_menu category_menu' :class='{slide_in_right: show}'>
    <div class='top'>
      <div class='close' @click.stop='close'>
        <span class='icon'></span>
        <i class='iconfont close_btn iconic_mobile_down'></i>
      </div>
    </div>
    <div class='menu_list'>
      <ul v-if='data'>
        <li class='item menu_all' @click='clickCate({name: $t("goods.category.all"), id: 0}, -1)'>
          <div>{{ $t('goods.category.all') }}</div>
          <div v-if='choosenIndex == "-1"' class='icon icon_cate_all'></div>
        </li>
        <li v-for='(item, index) in data' :key='index' class='item'>
          <div class='parent_item' @click='extendSubMenu(item, index)'>
            <div>{{ item.name }}</div>
            <div v-if='index == choosenIndex || index == choosenIndex.split("/")[0]' class='icon icon_cate_all'></div>
            <template v-if='item.subs && item.subs.length'>
              <div v-if='isExtend[index]' class='icon icon_cate_up'></div>
              <div v-else class='icon icon_cate_dw'></div>
            </template>
          </div>
          <template v-if='item.subs'>
            <div class='sub_item' :style='{height: isExtend[index] ? `${item.subs.length * 40}px` : 0}'>
              <div v-for='(child, childIndex) in item.subs' :key='child.id'
                   class='cur' :class='{active: `${index}/${childIndex}` == choosenIndex}'
                   @click='clickCate(child, `${index}/${childIndex}`)'
              >
                <div>{{ child.name }}</div>
                <div v-if='`${index}/${childIndex}` == choosenIndex' class='icon icon_right'></div>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsCateMenu',
  props: ['data', 'show', 'isChoosen', 'choosenIndex'],
  data () {
    return {
      isExtend: [],
    }
  },
  components: {},
  methods: {
    close () {
      this.$emit('close')
    },
    clickCate (item, index) {
      setTimeout(() => {
        this.close()
      }, 300)
      this.$emit('clickCate', item, index)
    },
    extendSubMenu (item, index) {
      if (item.subs && !item.subs.length) {
        this.clickCate(item, index)
      } else {
        this.$set(this.isExtend, index, !this.isExtend[index])
      }
    },
    init () {
      this.isExtend = Object.keys(this.data).map(() => false)
    },
  },
  mounted () {
    if (!this.data) return
    this.init()
  },
}
</script>
